import React from 'react';
import placeholder from '../../assets/images/mealDetailPlaceholderMobile.png';

const MealDetailLoadingMobile = () => {
  // console.log(`MealDetailLoadingMobile`);
  return (
    <div style={{ margin: 'auto', overflow: 'hidden' }}>
      <img src={placeholder} alt="Loading" />
    </div>
  );
};

export default MealDetailLoadingMobile;
